let merchantChannel: BroadcastChannel | null = null;

export const SetMerchantChannel = (merchantId: number) => {
  if (merchantChannel) {
    merchantChannel.close();
  }

  merchantChannel = new BroadcastChannel(merchantId.toString());

  /* eslint-disable @typescript-eslint/no-empty-function */
  merchantChannel.onmessage = (event) => {};
};
